import React, { useMemo, useState } from 'react';
import MaskedInput from 'react-text-mask';

import { getMask } from '../../../../utils/masks';
import { month_options } from '../../../../utils/creditCard';

import ErrorMessage from '../../error_message/ErrorMessage';
import ButtonStage from '../../../standard/button_stage/ButtonStage';
import CardPurchaseValidation from '../../card_purchase_validation/CardPurchaseValidation';
import { detectCardBrand, validateCreditCard } from '../../../../utils';

const CardInfoMobile = (props) => {
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [cvv, setCvv] = useState(props.creditCard.cvv);

  React.useEffect(() => {
    setCvv(props.creditCard.cvv);
  }, [props.creditCard.cvv]);

  const year_options = useMemo(() => {
    const now = new Date().getUTCFullYear();
    return Array.from({ length: 20 }, (_, i) => now + i);
  }, []);

  const cleanNumber = (number) => number.replace(/\D/g, '');

  const { detectedBrand, cardValid } = useMemo(() => {
    const number = props.creditCard.number || '';
    const brand = detectCardBrand(number);
    const valid = brand && validateCreditCard(brand, cleanNumber(number), 'number');
    return { detectedBrand: brand, cardValid: !!valid };
  }, [props.creditCard.number]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'expiry_month') setSelectedMonth(value);
    if (name === 'expiry_year') setSelectedYear(value);
    if (name === 'cvv') setCvv(value);

    if (name === 'number') {
      const currentBrand = detectCardBrand(value);
      if (currentBrand) {
        const brandIndex = props.brands.findIndex(b => b.brand_name === currentBrand);
        if (brandIndex !== -1 && !props.brands[brandIndex].selected) {
          props.selectCreditCardBrand(brandIndex);
        }
      }
    }

    props.changeCreditCardAttr({ name, value });
  };

  const cardErrors = props.errors;
  const hasCvvError = !!cardErrors.cvv;
  const input_credit_card = getMask(detectedBrand);

  return (
    <div className="a-form mobile" style={{ display: props.stepDisplayCreditCard !== 3 ? 'none' : 'block' }}>
      <h4>Informe os dados do seu cartão</h4>
      <CardPurchaseValidation />
      <form>
        <div className="row-input" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div className="cols" style={{ flex: 2 }}>
            <MaskedInput
              guide={false}
              type="tel"
              name="number"
              id="cc-number"
              inputMode="numeric"
              onChange={handleChange}
              mask={input_credit_card.mask}
              value={props.creditCard.number || ''}
              className={`${cardErrors.number ? 'with-error' : ''}`}
              placeholder="Número do cartão"
              onBlur={(e) => {
                props.validatorHandlerBlur(e.target.value, 'creditcard_number');
              }}
              keepCharPositions={true}
            />
          </div>
          <div className="cols">
            <div className="box-brandcard">
              {detectedBrand && (
                <img
                  src={`/assets/images/home/home/cards/v2/${detectedBrand}.svg`}
                  alt={detectedBrand}
                />
              )}
            </div>
          </div>
        </div>
        <ErrorMessage anchor={`number`} field1="creditCard" field2="number" />
        <div className="row-input-cols input-parcels">
          <div className='cols' style={{ flex: 2 }}>
            <select
              id="card-installments"
              name="parcels"
              disabled={!cardValid}
              onChange={(e) => {
                const idx = props.parcels.findIndex(p => p.times === Number(e.target.value));
                if (idx !== -1) props.selectCreditCardParcel(idx);
              }}
              value={(props.parcels.find(p => p.selected) && props.parcels.find(p => p.selected).times) || ''}
            >
              <option value="" disabled>
                Selecione o parcelamento:
              </option>
              {cardValid &&
                props.parcels.map((parcel, i) => (
                  <option value={parcel.times} key={i}>
                    {parcel.times}x de R$ {parcel.price}
                  </option>
                ))}
            </select>
          </div>
          <ErrorMessage anchor={`creditCard_parcels`} field1="creditCard" field2={'parcels'} />
        </div>
        <div className="row-input-cols input-date">
          <div className="cols">
            <select
              name="expiry_month"
              form=""
              id="cc-expiry-month"
              onChange={handleChange}
              className={`mes ${cardErrors.expiry_month ? 'with-error' : ''}`}
              onBlur={(e) => {
                props.validatorHandlerBlur(e.target.value, 'creditcard_month');
                setSelectedMonth(e.target.value);
              }}
              value={selectedMonth}
            >
              <option value="" disabled hidden>
                Mês
              </option>
              {month_options.map((month, i) => (
                <option value={month.value} key={i}>
                  {month.name}
                </option>
              ))}
            </select>
            <ErrorMessage anchor={`number`} field1="creditCard" field2="expiry_month" />
          </div>
          <div className="cols">
            <select
              name="expiry_year"
              id="cc-expiry-year"
              onChange={handleChange}
              className={`ano ${cardErrors.expiry_year ? 'with-error' : ''}`}
              onBlur={(e) => {
                props.validatorHandlerBlur(e.target.value, 'creditcard_year');
                setSelectedYear(e.target.value);
              }}
              value={selectedYear}
            >
              <option value="" disabled hidden>
                Ano
              </option>
              {year_options.map((year, i) => (
                <option value={year} key={i}>
                  {year}
                </option>
              ))}
            </select>
            <ErrorMessage anchor={`number`} field1="creditCard" field2="expiry_year" />
          </div>
        </div>

        <div className={`row-input-cols input-cvv${hasCvvError ? ' with-error' : ''}`}>
          <div className="cols input-credit">
            <MaskedInput
              type="tel"
              name="cvv"
              guide={false}
              inputMode="numeric"
              mask={[/\d/, /\d/, /\d/, /\d/]}
              id="cc-verfication-code"
              onChange={handleChange}
              value={cvv}
              placeholder="CVV"
              className={`${cardErrors.cvv ? 'with-error' : ''}`}
              onBlur={(e) => {
                props.validatorHandlerBlur(e.target.value, 'creditcard_cvv');
                setCvv(e.target.value);
              }}
            />
            <ErrorMessage className="form-error-message" anchor={`number`} field1="creditCard" field2="cvv" />
          </div>
          <div className="cols image-card">
            <img
              src={detectedBrand === 'amex' ? '/assets/images/cvv-icon-2.svg' : '/assets/images/cvv-icon.svg'}
              alt="cvv-card"
              className="img-brand"
            />
          </div>
          <div className="cols instruction">
            <span className="text-credit-card">
              {detectedBrand === 'amex' ? '4' : '3'} digitos <br />
              atrás do <br />
              cartão.
            </span>
          </div>
        </div>
        <div className="row-input">
          <input
            type="text"
            name="holder_name"
            id="cc-holder-name"
            placeholder="Nome do titular"
            onChange={handleChange}
            value={props.creditCard.holder_name}
            className={`${cardErrors.holder_name ? 'with-error' : ''}`}
            onBlur={(e) => {
              props.validatorHandlerBlur(e.target.value, 'creditcard_holdername');
            }}
          />
          <ErrorMessage anchor={`number`} field1="creditCard" field2="holder_name" />
        </div>
        <div className="row-input">
          <MaskedInput
            guide={true}
            name="holder_cpf"
            type="tel"
            value={props.creditCard.holder_cpf}
            mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
            id="cc-holder-cpf"
            placeholder="CPF"
            onChange={handleChange}
            className={`upper ${cardErrors.holder_cpf ? 'with-error' : ''}`}
            onBlur={(e) => {
              props.validatorHandlerBlur(e.target.value, 'creditcard_holdercpf');
            }}
          />
          <ErrorMessage anchor={`number`} field1="creditCard" field2="holder_cpf" />
        </div>
      </form>
      <ButtonStage data-cy="step-payment-data" index={3} stage="INSURED_PAYMENT_PURCHASE" />
    </div>
  );
};

export default CardInfoMobile;


// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/CreditCard/CardInfoMobile.jsx